import React from "react"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { Box } from "@mui/material"
import { dsColorNew } from "@palette"


export default function ReportFormDrawerCsvTableActions({ onDownload, onDelete }) {

	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
		<ButtonIconSeeker
			tooltip="Download file"
			icon="download"
			onClick={onDownload}
			onAuxClick={onDownload}
			sx={{ color: dsColorNew.textMuted, width: 36, height: 36, borderRadius: '8px', fontSize: 15 }}
		/>
		<ButtonIconSeeker
			tooltip="Remove file"
			icon="trash"
			onClick={onDelete}
			sx={{ color: dsColorNew.dangerRed, width: 36, height: 36, borderRadius: '8px', fontSize: 15 }}
		/>
	</Box>
}
